import {SSLAConfiguration} from "./config";

type LogLevel = string;
export const Debug: LogLevel = "debug";
export const Warning: LogLevel = "warning";
export const Error: LogLevel = "error";

export function show(config: SSLAConfiguration, level: LogLevel, msg: string) {
    if (config.logMessageBehavior() == "console") {
        showConsole(level, msg);
    } else if (config.logMessageBehavior() == "alert") {
        showAlert(level, msg);
    } else if (config.logMessageBehavior() == "alertErrorOnly") {
        if (level == Error) {
            showAlert(level, msg);
        } else {
            showConsole(level, msg);
        }
    } else if (config.logMessageBehavior() == "custom") {
        let fn = config.logMessageCustomFunction();
        if (!fn) {
            alert("Error message custom function unavailable.");
            console.log("Error message custom function unavailable.")
        }
        fn(level, msg);
    } else {
        alert("Unknown configuration type for `logMessageBehavior`: " + config.logMessageBehavior());
        console.log("Unknown configuration type for `logMessageBehavior`: " + config.logMessageBehavior());
    }
}

export function showAlert(level: string, msg: string) {
    alert(msg);
}

export function showConsole(level: string, msg: string) {
    console.log(msg);
}